export class Embebido {
    public uuid: string;
    public codCliente: string = "";
}